import { gql } from '@apollo/client';

export const ChangeProfile = gql`
    mutation changeProfile(
        $firstName: String!
        $lastName: String!
        $phoneNumber: String
        $companyName: String
        $website: String
        $language: Int
    ) {
        changeProfile(
            firstName: $firstName
            lastName: $lastName
            phoneNumber: $phoneNumber
            companyName: $companyName
            website: $website
            language: $language
        ) {
            ... on ChangeProfileResponse {
                message
                company {
                    id
                    name
                }
            }
        }
    }
`;
